module.exports = __webpack_public_path__ + "img/fusion-reactor.bcac4529.png";